import React from "react";

function NotEqual() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="not-equal" className="svg-inline--fa fa-not-equal fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M35.59 466.83a16 16 0 0 0 3 22.42L64 508.75a16 16 0 0 0 22.43-3L168.52 400h-81zM162 304h81l74.51-96h-81zM441 22.78L415.61 3.29a16 16 0 0 0-22.43 3L311.11 112h81L444 45.21a16 16 0 0 0-3-22.43z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M416 304H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32zm0-192H32a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32z"></path></g></svg>
    );
  }

export default NotEqual;